var map = {
	"./format-closeup_poster_large.svg": "JLZJ",
	"./format-closeup_poster_medium.svg": "EH11",
	"./format-large.svg": "Xdf4",
	"./format-medium.svg": "gh9E",
	"./format-panorama_poster_large.svg": "odvS",
	"./format-panorama_poster_medium.svg": "Crw3",
	"./format-round_large.svg": "Vpcn",
	"./format-round_medium.svg": "oHxy",
	"./format-small.svg": "xHik"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kc14";